<template>
  <img
    class="vip-level-icon"
    :width="width"
    :height="height || width"
    :src="productLogo"
    v-if="(curData.CompID || curData.CompId) && productLogo"
  />
</template>

<script>
// iconType=1
import golden from "@/assets/images/search/golden.png";
import silver from "@/assets/images/search/silver.png";
import copper from "@/assets/images/search/copper.png";
// iconType=2
import vipLevel32 from "@/assets/images/search/vipLevel32.png";
import vipLevel4 from "@/assets/images/search/vipLevel4.png";
import vipLevel2 from "@/assets/images/search/vipLevel2.png";

// 会员等级 （金/银/铜/无）
export default {
  name: "vip-level-icon",
  props: {
    iconType: { default: 0 },
    width: {
      default: 16,
      type: [Number, String],
    },
    height: {
      type: [Number, String],
    },
    curData: {
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    // >=64钻石、>=32金、>=4银、>=2铜 >2无
    productLogo() {
      let vipLevel = (this.curData.CompVipLevel || this.curData.VipLevel);
      if ((vipLevel & 64) == 64) {
        return ''
      } else if ((vipLevel & 32) == 32) {
        return [golden, vipLevel32][this.iconType]
      } else if ((vipLevel & 4) == 4) {
        return [silver, vipLevel4][this.iconType]
      } else if ((vipLevel & 2) == 2) {
        return [copper,vipLevel2][this.iconType]
      } else {
        return ''
      }
    },
  },
};
</script>
<style scoped="scoped">
.vip-level-icon {
  object-fit: contain;
  vertical-align: middle;
}
</style>
